import { InputGroup, Input, InputRightElement, Button, InputProps } from '@chakra-ui/react';
import { useState } from 'react';

// SecretField is a field component used for passwords, API secrets, etc.
// Adapted from https://chakra-ui.com/docs/components/form/input#password-input-example
export const SecretField: React.FC<InputProps> = (props) => {
    const [show, setShow] = useState(false);

    return (
        <InputGroup size="md">
            <Input pr="4.5rem" type={show ? 'text' : 'password'} {...props} />
            <InputRightElement>
                <Button h="1.75rem" size="sm" onClick={() => setShow(!show)}>
                    {show ? 'Hide' : 'Show'}
                </Button>
            </InputRightElement>
        </InputGroup>
    );
};
